import { getToken } from '../../authentication/authProvider';

const API_URL = process.env.REACT_APP_PAPERMAN_API_URL || 'http://localhost:3001';
const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;

// In-memory cache so we don't re-translate the same message
const translationCache = new Map<string, string>();

export async function translateText(
  text: string,
  to: 'en' | 'fr',
  cacheKey?: string | number,
): Promise<string> {
  const key = cacheKey != null ? `${cacheKey}-${to}` : `${text}-${to}`;
  const cached = translationCache.get(key);
  if (cached) return cached;

  const token = await getToken();
  const response = await fetch(`${baseUrl}/translate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ text, to }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || `Translation failed (${response.status})`);
  }

  const data = await response.json();
  translationCache.set(key, data.translation);
  return data.translation;
}
